module.exports = __webpack_public_path__ + "img/crayon.3144d9db.svg";